import { render, staticRenderFns } from "./chat-quick-replies.vue?vue&type=template&id=12b57e16&scoped=true&"
import script from "./chat-quick-replies.vue?vue&type=script&lang=js&"
export * from "./chat-quick-replies.vue?vue&type=script&lang=js&"
import style0 from "./chat-quick-replies.vue?vue&type=style&index=0&id=12b57e16&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b57e16",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b57e16')) {
      api.createRecord('12b57e16', component.options)
    } else {
      api.reload('12b57e16', component.options)
    }
    module.hot.accept("./chat-quick-replies.vue?vue&type=template&id=12b57e16&scoped=true&", function () {
      api.rerender('12b57e16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-quick-replies/chat-quick-replies.vue"
export default component.exports